import { useAppSelector } from "@/reducers/hooks"
import { selectLocation } from "@/reducers/locationsSelectors"
import { useMemo } from "react"

export default function useDriverCurrentLocation(locationJid: string): {
  bearing: number | undefined
  currentLocation: [number, number]
} {
  const location = useAppSelector(selectLocation(locationJid))
  return useMemo(() => {
    return {
      bearing: location?.bearing ? parseInt(location.bearing, 10) : undefined,
      currentLocation: [
        parseFloat(location?.lon ?? "50"),
        parseFloat(location?.lat ?? "20"),
      ] as [number, number],
    }
  }, [location?.lon, location?.lat, location?.bearing])
}
